export default "__VITE_ASSET__CxZ1nFxT__"